// EpicDemoPatient
export * from './Editor_EpicDemoPatient.js';
//# sourceMappingURL=index.js.map